export default "__VITE_ASSET__d9c4d485__"